import ImageClass from "../../src/shell/Image";
import { jump } from "../../src/shell/jump";
import Question from "../../src/shell/Questions";
import { images } from "./images";

import { mc } from "../characters/MC";
import { vanessa } from "../characters/Vanessa";
import { V9VanessaMorningAfter } from "./V9";
import { doImageShake, doTransition, doWaitImageByTime, isFollowingVanessaLead } from "../helpers/helpers";

export const V9VanessaMorning = async (): Promise<any> => {
    doWaitImageByTime(images.v2_5.BlackScreen, null, 2);
    doImageShake(images.v9.V9VanessaMorning_1);
    if (isFollowingVanessaLead()) {
        vanessa.talk(`GOOD MORNING CADET!!!`);
    } else {
        vanessa.talk(`GOOD MORNING CAPTAIN!!!`);
    }
    ImageClass.setImage(images.v9.V9VanessaMorning_2);
    mc.talk(`WHAT THE FUCK???`);
    if (!isFollowingVanessaLead()) {
        ImageClass.setImage(images.v9.V9VanessaMorning_3);
        vanessa.talk(`Cadet Vanessa reporting for booty!`);
    }
    mc.talk(`What are you doing? Are you insane?`);

    // if this happened - doesn't matter true or false
    if (Question.globalAnswers.v8VanessaNightFuckHer !== undefined) {
        mc.talk(`When did you get up anyway? You were just sleeping next to me!`);
        ImageClass.setImage(images.v9.V9VanessaMorning_4);
        vanessa.talk(`I have a special set of skills.`);
        vanessa.talk(`Anyway!`);
    } else {
        ImageClass.setImage(images.v9.V9VanessaMorning_4);
        vanessa.talk(`Not at all!`);
    }

    ImageClass.setImage(images.v9.V9VanessaMorning_5);
    if (isFollowingVanessaLead()) {
        vanessa.talk(`It's time to start the fuckaton!`);
    } else {
        vanessa.talk(`I allowed myself to come up with some ideas for my training!`);
    }
    mc.talk(`I can see that...`);

    ImageClass.setImage(images.v9.V9VanessaMorning_6);
    vanessa.talk(`So, let's see what we've got today...`);
    mc.talk(`...`);
    ImageClass.setImage(images.v9.V9VanessaMorning_7);
    vanessa.talk(`Fucking!`);

    mc.talk(`Of course.`);

    ImageClass.setImage(images.v9.V9VanessaMorning_8);
    vanessa.talk(`I hope you didn't forget about our little bet.`);
    ImageClass.setImage(images.v9.V9VanessaMorning_9);
    mc.talk(`How can I when you remind me every five minutes?`);
    ImageClass.setImage(images.v9.V9VanessaMorning_8);
    vanessa.talk(`Don't you agree it's time to put it to the test?`);

    ImageClass.setImage(images.v9.V9VanessaMorning_10);
    if (isFollowingVanessaLead()) {
        vanessa.talk(`Today is the first challenge to see if you can keep up with me!`);
    } else {
        vanessa.talk(`I'm ready to be put to the test and see what it takes for me to be in your shoes!`);
    }

    if (Question.globalAnswers.v7VanessaGiveCustomerWhatHeWants) {
        mc.talk(`Why are you even here? Don't you have a job now?`);
        ImageClass.setImage(images.v9.V9VanessaMorning_10);
        vanessa.talk(`I show up when I want, that's why I wanted it back so badly.`);
    }

    ImageClass.setImage(images.v9.V9VanessaMorning_9);
    // happened
    if (Question.globalAnswers.v8VanessaNightLickHer !== undefined) {
        mc.talk(`I see you won't let me sleep today...`);
    } else {
        mc.talk(`Fine...`);
    }
    mc.talk(`Give me some time to wake up...`);
    mc.talk(`In the meantime, you can go and get changed into something... else...`);

    if (isFollowingVanessaLead()) {
        ImageClass.setImage(images.v9.V9VanessaMorning_10);
        vanessa.talk(`Oh boy! I know exactly what to wear!`);
    } else {
        ImageClass.setImage(images.v9.V9VanessaMorning_11);
        vanessa.talk(`Aye aye, Sir!`);
    }

    ImageClass.setImage(images.v9.V9VanessaMorning_10.partials.V9VanessaMorning_19, { putParent: true });
    vanessa.talk(`Oh, I just remembered!`);
    vanessa.talk(`Did my package arrive? I could put that on!`);
    mc.talk(`Mmm... It did... But how --`);
    ImageClass.setImage(images.v9.V9VanessaMorning_16);
    vanessa.talk(`Where is it? Show me!`);
    mc.talk(`Alright...`);
    ImageClass.setImage(images.v9.V9VanessaMorning_12);
    mc.talk(`There it is.`);
    ImageClass.setImage(images.v9.V9VanessaMorning_13);
    vanessa.talk(`What the fuck is this?`);
    ImageClass.setImage(images.v9.V9VanessaMorning_15);
    mc.talk(`Your package...?`);
    ImageClass.setImage(images.v9.V9VanessaMorning_16);
    vanessa.talk(`First of all, it's way too small to fit what I ordered!`);
    vanessa.talk(`And even if it wasn't... It's empty!`);

    ImageClass.setImage(images.v9.V9VanessaMorning_16);
    mc.talk(`Wait... What did you order in the first place?`);
    ImageClass.setImage(images.v9.V9VanessaMorning_17);
    vanessa.talk(`A sexy outfit, DUH!`);
    ImageClass.setImage(images.v9.V9VanessaMorning_18);
    mc.think(`If that's not what Vanessa ordered... Who ordered it?`);
    mc.talk(`I guess your package didn't arrive then...`);
    vanessa.talk(`...`);
    ImageClass.setImage(images.v9.V9VanessaMorning_14);
    vanessa.talk(`I'll go change now, I guess.`);

    return jump(V9VanessaMorningAfter, "V9VanessaMorningAfter");
};
